// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".total-box{background-color:rgba(126,87,194,.4);padding:10px 20px;font-size:16px;border-radius:4px;margin-right:2px;width:202px}.total{font-weight:700;font-size:20px}.line-up{margin-right:35px;display:inline-block}", ""]);
// Exports
module.exports = exports;
